import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MediaObserver } from '@angular/flex-layout';
import { filterDateAnim } from 'src/app/models/consts/anims';
import { ClientRefillsService } from 'src/app/services/apiclient/clientrefills/clientrefills.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ClientMerchantsService } from 'src/app/services/apiclient/clientmerchants/clientmerchants.service';
import { TranslateArrayService } from 'src/app/services/translateArray/translate';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-refills',
  templateUrl: './refills.component.html',
  styleUrls: ['./refills.component.css'],
  animations: [
    filterDateAnim,
  ]
})
export class RefillsComponent implements OnInit {

  @ViewChild('pageTitle') pageTitle: ElementRef|any;
  @ViewChild(MatPaginator) paginator: MatPaginator|any;
  @ViewChild(MatSort) sort: MatSort|any;

  currMerchant: any;

  loader: boolean = true;
  refillsLoader: boolean = true;

  statusMessage: any =this.translate.instant('refillsComponent.messageLoaderGetRefill'); 

  titlePositionTop: number|any;

  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>();
  displayedColumns: string[] = ['date', 'value', 'print'];

  filterDateAnimFlag: boolean = false;

  get getToggleFilterDate(): string { return this.filterDateAnimFlag ? "show" : "hide"; }

  constructor(
    public media: MediaObserver,
    private refillsApi: ClientRefillsService,
    private clientMerchantApi: ClientMerchantsService,
    private router: Router,
    private route: ActivatedRoute,
    private TranslateArrayService: TranslateArrayService,
    public translate: TranslateService
  ) {
    this.media.asObservable().subscribe(media => {
      if (this.titlePositionTop) {
        this.titlePositionTop = this.pageTitle.nativeElement.getBoundingClientRect().top + 15;
      }
    });
  }

  ngOnInit() {

    this.route.params.subscribe((params:any) => {

      if (params.merchantId) {

        this.clientMerchantApi.getMerchant(params.merchantId).subscribe(merchant => {

          this.currMerchant = merchant;

          this.refillsApi.getRefills(merchant.id_user).subscribe(refills => {
               

            setTimeout(() => {
              this.dataSource.data = refills;
              this.dataSource.paginator = this.paginator;
              this.dataSource.paginator = this.TranslateArrayService.get(this.dataSource.paginator);
              this.dataSource.sort = this.sort;
            });

            this.loader = false;
            this.refillsLoader = false;

            setTimeout(() => {
              this.titlePositionTop = this.pageTitle.nativeElement.getBoundingClientRect().top + 15;
            });

          });

        })

      } else {

        this.router.navigate(["/404", this.translate.instant('error404.Urlincomplet')]);

      }

    });

  }

  goBack(): void {
    this.router.navigate(["/home/cashlessOptions" + "/" + this.currMerchant.id_user]);
  }

  goInvoiceRecharge(recharge: any) {
   
     window.open(window.location.origin + "/invoiceRecharge" + "/" + this.currMerchant.id_user + "/" + recharge.id, "_blank");
  }

  setRefillsLoader(flag: boolean) {
    if (flag) {
      this.filterDateAnimFlag = false;
    }
    this.refillsLoader = flag;
  }

  setRefills(refills: any) {
    this.dataSource.data = refills;
 
  }

}
